import React from "react"
import {Box, Stack, Typography} from "@mui/material";
import {CmCollection} from "../../../../packages/graphql-layer/src";

import CCOSvg from "../../fundamentals/CCOSvg";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import useWindowSize from "../../../utility/useWindowSize";

export interface Props {
    cmCollection: CmCollection,
    CAEGlobalSettings: any,
}

function C071SocialRow(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize();
    const gridStyle = {

        width: '100%',
        height: '100%',
        padding: '24px 16px 16px 16px',
    }
    const stackStyleCenter = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center'
    }
    const noStackStyle = {}
    return (<>
            <Box id={props.cmCollection.id} sx={gridStyle}>
                <Stack direction="row" alignItems="center" gap={4}
                       style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}>
                    <Typography sx={{fontSize: 16, pb: 1, }}> {props.cmCollection.teaserTitle} </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={4}
                       style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}>
                    {
                        props.cmCollection.items?.map((item: any, index)  => (
                            <Box  key={index}  sx={{ textAlign: 'center'}}>
                                {item.globalFactsSettings?.teaser_icon ?
                                    <CCOLinkable dataCypress={'socialMediaLink' + index} target={item} openInTab={true} noLinkIcon={true}>
                                            <CCOSvg uri={item.globalFactsSettings?.teaser_icon} alt={item.globalFactsSettings?.teaser_icon_alt} size={24}/>
                                    </CCOLinkable>
                                    : null}
                            </Box>
                        ))
                    }
                </Stack>


            </Box>
        </>
    )
}

export default C071SocialRow